// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import managePartners from './managePartners';

import { IRoute } from '../';

const managePartnersRoutes: IRoute[] = [
    {
        crumbText: 'manage_partners',
        component: managePartners,
        exact: true,
        path: '/managePartners',
    },
];

export default managePartnersRoutes;